import { ReturnsActionTypes, ReturnsState } from "@actions/returns.actions";
import {
  FETCH_RETURNS_REQUEST,
  FETCH_RETURNS_SUCCESS,
  FETCH_RETURNS_FAILURE,
} from "./actionTypes";

const initialState: ReturnsState = {
  data: {},
  loading: false,
  error: null,
};

const returnsReducer = (
  state = initialState,
  action: ReturnsActionTypes,
): ReturnsState => {
  switch (action.type) {
    case FETCH_RETURNS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_RETURNS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_RETURNS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default returnsReducer;
